import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { ToastAlertSliceType } from './types';

const initialState: ToastAlertSliceType = {
  status: 'success',
  message: '',
};

const toastAlertSlice = createAppSlice({
  name: 'toastAlert',
  initialState,
  reducers: {
    setToastAlert(_, action: PayloadAction<ToastAlertSliceType>) {
      return action.payload;
    },
    resetToastAlert() {
      return initialState;
    },
  },
});

export const { setToastAlert, resetToastAlert } = toastAlertSlice.actions;
export default toastAlertSlice.reducer;
